@if (dialog().open) {
  <div class="ct-dialog-backdrop" (click)="dialogService.dismiss()">
    <div
      class="ct-dialog confirm-dialog"
      role="alertdialog"
      aria-modal="true"
      [attr.aria-labelledby]="'confirm-dialog-title'"
      [attr.aria-describedby]="'confirm-dialog-message'"
      (click)="$event.stopPropagation()"
      (keydown.escape)="dialogService.dismiss()"
    >
      <header class="ct-dialog-head">
        <h2 id="confirm-dialog-title">{{ dialog().title }}</h2>
        <button
          type="button"
          class="ct-dialog-close"
          (click)="dialogService.dismiss()"
          [attr.aria-label]="cancelLabel()"
        >
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="ct-dialog-body">
        <p id="confirm-dialog-message" class="confirm-dialog__message">{{ dialog().message }}</p>
      </div>
      <div class="ct-dialog-actions">
        @if (dialog().mode === 'confirm') {
          <button class="ct-btn ct-btn-ghost" type="button" (click)="dialogService.dismiss()">
            {{ cancelLabel() }}
          </button>
        }
        <button
          class="ct-btn"
          [class.ct-btn-danger]="dialog().danger"
          [class.ct-btn-primary]="!dialog().danger"
          type="button"
          (click)="dialogService.accept()"
        >
          {{ confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
